import React from 'react';
import { CheckCircle2, Play } from 'lucide-react';
import type { Recording } from '../../types/portal';

interface Props {
  recording: Recording;
  number: number;
  done: boolean;
  toggling: boolean;
  isNew?: boolean;
  onToggleCompleted: () => void;
  onPlay: () => void;
}

const LessonRow: React.FC<Props> = ({
  recording,
  number,
  done,
  toggling,
  isNew = false,
  onToggleCompleted,
  onPlay,
}) => (
  <li className="flex items-center gap-3 px-4 py-3.5 hover:bg-gray-50 dark:hover:bg-neutral-800 transition-colors">
    <button
      onClick={onToggleCompleted}
      disabled={toggling}
      className={`shrink-0 transition-all duration-200 ${
        toggling ? 'opacity-50' : 'hover:scale-110'
      }`}
      title={done ? 'Als nicht gesehen markieren' : 'Als gesehen markieren'}
    >
      {done ? (
        <CheckCircle2 className="h-6 w-6 text-[#970000] dark:text-red-400" />
      ) : (
        <div className="w-6 h-6 rounded-full border-2 border-gray-300 dark:border-neutral-600 flex items-center justify-center">
          <span className="text-[10px] font-bold text-gray-500 dark:text-neutral-400">{number}</span>
        </div>
      )}
    </button>
    <div className="flex-1 min-w-0">
      <p
        className={`text-sm font-semibold leading-snug line-clamp-1 ${
          done ? 'text-gray-400 dark:text-neutral-500' : 'text-gray-900 dark:text-neutral-100'
        }`}
      >
        {recording.title}
        {isNew && (
          <span className="ml-2 align-middle text-[9px] font-bold tracking-wider uppercase bg-[#970000] text-white px-1.5 py-0.5 rounded">
            Neu
          </span>
        )}
      </p>
      <p className="text-xs text-gray-400 dark:text-neutral-500 mt-0.5">
        YouTube-Lektion
        {recording.recorded_at &&
          ` · ${new Date(recording.recorded_at).toLocaleDateString('de-DE')}`}
      </p>
    </div>
    <button
      onClick={onPlay}
      className="shrink-0 w-8 h-8 rounded-full border border-gray-200 dark:border-neutral-800 flex items-center justify-center text-gray-500 dark:text-neutral-400 hover:bg-[#970000] hover:text-white hover:border-[#970000] transition-all duration-200"
    >
      <Play className="h-3.5 w-3.5 ml-0.5" />
    </button>
  </li>
);

export default LessonRow;
